import { render, staticRenderFns } from "./store_getStoreProduceList.vue?vue&type=template&id=3a55b1a8"
import script from "./store_getStoreProduceList.vue?vue&type=script&lang=js"
export * from "./store_getStoreProduceList.vue?vue&type=script&lang=js"
import style0 from "./store_getStoreProduceList.vue?vue&type=style&index=0&id=3a55b1a8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports